export default {
  type: "uvm_pkg"
};
